import React from 'react';

import { Button, Grid, Modal } from '@mui/material';

import ModalContainer, { ModalToolbar } from './Modal.styled';
import { Heading } from 'components/Typography';

const modalStyles = {
  margin: '1rem',
};

const buttonStyles = {
  fontSize: 12,
  width: '150px',
  padding: '8px 5px',
};

const cancelButtonStyles = {
  color: 'text.disabled',
  borderColor: 'text.disabled',
};

const ModalForm = ({
  children,
  title,
  isOpen,
  onClose,
  onSubmit,
  maxWidth = 400,
}) => {
  return (
    <Modal open={isOpen} onClose={onClose} sx={modalStyles}>
      <ModalContainer maxwidth={maxWidth}>
        <Heading mb={4} content={title} as="h2" />

        <form onSubmit={onSubmit} noValidate>
          <Grid container spacing={2}>
            {children}
          </Grid>
        </form>

        <ModalToolbar>
          <Button
            size="small"
            onClick={onClose}
            variant="outlined"
            sx={{ ...buttonStyles, ...cancelButtonStyles }}
          >
            Cancel
          </Button>

          <Button
            size="small"
            onClick={onSubmit}
            variant="outlined"
            color="success"
            sx={buttonStyles}
          >
            Save
          </Button>
        </ModalToolbar>
      </ModalContainer>
    </Modal>
  );
};

export default ModalForm;
